import { classNames } from "@ember-decorators/component";
import TopicStatus from "discourse/components/topic-status";
import boundCategoryLink from "discourse/helpers/bound-category-link";
import replaceEmoji from "discourse/helpers/replace-emoji";
import SelectKitRowComponent from "select-kit/components/select-kit/select-kit-row";
import { precompileTemplate } from "@ember/template-compilation";
import { setComponentTemplate } from "@ember/component";
const TopicRow = dt7948.c(class TopicRow extends SelectKitRowComponent {
  static {
    setComponentTemplate(precompileTemplate("\n    <TopicStatus @topic={{this.item}} @disableActions={{true}} />\n    <div class=\"topic-title\">{{replaceEmoji this.item.title}}</div>\n    <div class=\"topic-categories\">\n      {{boundCategoryLink this.item.category ancestors=this.item.category.predecessors hideParent=true link=false}}\n    </div>\n  ", {
      strictMode: true,
      scope: () => ({
        TopicStatus,
        replaceEmoji,
        boundCategoryLink
      })
    }), this);
  }
}, [classNames("topic-row")]);
export default TopicRow;